import {_debounce} from "../../app/helpers";

document.addEventListener('DOMContentLoaded', () => {
  const showChannelBtn = document.querySelector('.js--channel_btn');
  const closeFilterLink = document.querySelector('.js--filter_close');
  const channelList = document.querySelector('.js--channel_list');
  const showChannelBtnMob = document.querySelector('.js--show_filter_mob');
  const archiveMain = document.querySelector('.js--archive_main');
  const archiveChannels = document.querySelector('.js--archive_rubrics');
  const archiveChannelsHeader = document.querySelector('.js--archive_channels_header');
  const resetFilterBtn = document.querySelector('.js--reset');
  const $body = document.body;
  const $root = document.getElementsByTagName('html')[0];
  const $screen = document.querySelector('.screen');

  const openFilter = () => {
    if (channelList) {
      channelList.classList.add('showOnSide');
    }
    $body.classList.add('filterIsOpen');
    $root.classList.add('filterIsOpen');
  };

  const closeFilter = () => {
    if (channelList) {
      channelList.classList.remove('showOnSide');
    }
    $body.classList.remove('filterIsOpen');
    $root.classList.remove('filterIsOpen');
  };

  if (showChannelBtnMob) {
    showChannelBtnMob.addEventListener('click', function () {
      openFilter();
    })
  }

  $screen.addEventListener('click', closeFilter);
  if (closeFilterLink) {
    closeFilterLink.addEventListener('click', closeFilter);
  }
if (showChannelBtn) {
  showChannelBtn.addEventListener('click', function () {
    channelList.classList.toggle('show');
    archiveChannelsHeader.classList.toggle('show');
    archiveChannels.classList.toggle('show');
    if (archiveMain.classList.contains('col-lg-8')) {
      archiveMain.classList.remove('col-lg-8');
      archiveChannels.classList.remove('col-lg-4');
      archiveMain.classList.add('col-lg-12');
    } else if (archiveMain.classList.contains('col-lg-12')) {
      archiveMain.classList.remove('col-lg-12');
      archiveMain.classList.add('col-lg-8');
      archiveChannels.classList.add('col-lg-4');
    } else if (archiveMain.classList.contains('col-lg-6')) {
      archiveMain.classList.remove('col-lg-6');
      archiveChannels.classList.remove('col-lg-3');
      archiveMain.classList.add('col-lg-9');
    } else if (archiveMain.classList.contains('col-lg-9')) {
      archiveMain.classList.remove('col-lg-9');
      archiveMain.classList.add('col-lg-6');
      archiveChannels.classList.add('col-lg-3');
    }
  });

}

  function resetCheckboxesInQueryString() {
    const params = new URLSearchParams(window.location.search);
    const checkboxNames = new Set(Array.from(document.querySelectorAll('input[type="checkbox"]')).map(checkbox => checkbox.name));

    checkboxNames.forEach(name => {
      const cleanName = name.replace('[]', '');
      params.delete(cleanName);
    });

    const newUrl = `${window.location.pathname}?${params.toString()}`;
    history.replaceState(null, '', newUrl);

    document.querySelectorAll('input[type="checkbox"]').forEach(checkbox => {
      checkbox.checked = false;
    });
    document.dispatchEvent(new Event('channelChange'));
  }


if (resetFilterBtn) {
  resetFilterBtn.addEventListener('click', function(e) {
    e.preventDefault();
    resetCheckboxesInQueryString();
    resetFilterBtn.classList.add('active');
  });
}

  const checkboxes = document.querySelectorAll('.js--channel_item');

  function updateQueryStringWithCheckboxes() {
    let currentParams = window.location.search ? window.location.search.substring(1).split('&') : [];
    const params = {};

    currentParams.forEach(param => {
      const [key, value] = param.split('=');
      if (!params[key] && !document.querySelector(`input[name="${key}[]"]`)) {
        params[key] = decodeURIComponent(value);
      }
    });

    const checkboxNames = new Set(Array.from(document.querySelectorAll('input[type="checkbox"]')).map(checkbox => checkbox.name));

    checkboxNames.forEach(name => {
      const cleanName = name.replace('[]', '');

      const selectedValues = Array.from(document.querySelectorAll(`input[name="${name}"]:checked`))
          .map(checkbox => checkbox.value);

      if (selectedValues.length > 0) {
        if (params[cleanName]) {
          params[cleanName] += `,${selectedValues.join(',')}`;
        } else {
          params[cleanName] = selectedValues.join(',');
        }
      }
    });

    const newQueryString = Object.entries(params)
        .map(([key, value]) => `${key}=${value}`)
        .join('&');

    const newUrl = `${window.location.pathname}?${newQueryString}`;
    history.replaceState(null, '', newUrl);
  }


  let debounceTimeout;
  if (checkboxes.length) {
    checkboxes.forEach(function (checkbox) {
      checkbox.addEventListener('change', function () {
        if (resetFilterBtn && resetFilterBtn.classList.contains('active')) {
          resetFilterBtn.classList.remove('active');
        }
        clearTimeout(debounceTimeout);

        // TODO: use _debounce from helpers
        // _debounce();
        updateQueryStringWithCheckboxes();

        debounceTimeout = setTimeout(function () {
          document.dispatchEvent(new Event('channelChange'));
        }, 500);
      });
    });

  }
});
